module.exports = __webpack_public_path__ + "pcstatic/img/fenlei .f6971e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/fenlei .png
// module id = c+ux
// module chunks = 22